import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import ShowPlate from '../../../pages/expert/ShowPlate';
import Input from '../../master/Input';
import SearchablePicker from '../../master/SearchablePicker';
import DatePicker from '../../master/DatePicker';
import InsuranceInfoIcon from '../../../assets/images/icons/car-info-orange.png'
import { pexios, toast, UserLabel, validate } from '../../../utils/functions';
import ContactBox from '../../master/ContactBox';
import HeaderIcon from '../../../assets/images/header-icon/insurance-info.png'
import { useSelector } from 'react-redux';

export default function InsuranceInfo({data,userType,hasBodyInsurance,changeData,handleEditInfo,changeStep,btnLoading}) {
    const {accidentInfo} = useSelector(store => store);
    const [supportCall,setSupportCall] = useState(false)
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [includedInsurance, setIncludedInsurance] = useState([]);
    const form =useRef(null);
    const { t } = useTranslation();
    // const {setTitle} = useContext(TitleContext)
    // useEffect(()=>{
    //     setTitle(` ${data.third?.final_check ? 'تایید' : ''} بیمه نامه ثالث ${userType === 'culprit' ? 'مقصر' : 'زیان دیده'}`)
    // },[])
    useEffect(() => {
        pexios('api/get_insurance_wallet_check')
            .then(res => {
                setIncludedInsurance([...res.data]);
            });
    }, []);
    useEffect(() => {
        pexios('api/v2/get_insurance')
            .then(res => {
                setInsuranceCompanies(res.data.data);
            });
    }, []);
    function Submit(type) {
        const err = validate(form);
        if (err.length) {
            toast(t('Complete required fields',{err:err}), 'error');
            return
        } 
        handleEditInfo(type)
    }
    return (
    <>
        {supportCall && <ContactBox isOpen={supportCall} close={()=>setSupportCall(false)}/>}
                <div className='title-image'>
                    <img src={HeaderIcon} alt="icon"/>
                </div>
                <p className='guide-text mx10 mt10'>
                لطفا اطلاعات مربوط به بیمه نامه شخص ثالث {accidentInfo.insurance_type === 'body' ? 'و بدنه' : UserLabel(userType)} را بررسی و درصورت نیاز تکمیل نمایید.
                </p>
                {/* {!!(data.third?.insurance_company && data.third?.final_check) &&
                    <>
                <div className='plate-container mt10'>
                    <ShowPlate
                        plate={{
                            plate_iran: data.plate_iran,
                            plate_left: data.plate_left,
                            plate_center: data.plate_center,
                            plate_right:  data.plate_right,
                            plate_type: data.plate_type
                        }}
                        />
                    </div>
                    
                    <div className='d-flex car-info br5 p10 mt10'>
                        <div className='d-flex align-items-center mr10 text-right'>
                            {insuranceCompanies[data.third.insurance_company-1]?.title} - {data.third?.insurance_number}
                            <img className='ml10' src={InsuranceInfoIcon}/>
                        </div>
                        </div>
                    <div className='edit-text mt20'>
                        <p className='m5'> در صورت مغایرت اطلاعات ،با <span className='colorful-text' onClick={()=> setSupportCall(true)}>پشتیبانی</span> تماس حاصل نمایید.</p>
                    </div>
                    </>
                    } */}
                    <div className='row text-right' ref={form}>

                    {
                    // !!(!data.third?.final_check) &&
                        <>
                        <Input
                            label='نام بیمه گزار ثالث'
                            value={data.third?.insurance_owner_name}
                            onChange={value => changeData(value, 'insurance_owner_name','third')}
                            name='fname'
                            required
                            // disabled={data.third?.final_check}
                        />
                        <Input
                            label='کد ملی بیمه گزار ثالث'
                            value={data.third?.insurance_owner_national_id}
                            maxLength={10}
                            mode='numeric'
                            name='nationalId'
                            onChange={value => changeData(value, 'insurance_owner_national_id','third')}
                            required
                            // disabled={data.third?.final_check}
                        />
                        <Input
                            label={t('Third insurance number')}
                            value={data.third?.insurance_number}
                            // disabled={data.third?.final_check}
                            onChange={value => changeData(value, 'insurance_number','third')}
                            required
                            minLength={4}
                        />
                        <SearchablePicker
                            label={t('Third insurance company')}
                            value={data.third?.insurance_company || ''}
                            data={!hasBodyInsurance ? includedInsurance:insuranceCompanies}
                            titleKey='title'
                            valueKey='id'
                            rtl
                            // disabled={data.third?.final_check}
                            onSelect={val => changeData(val, 'insurance_company','third')}
                            required
                            hasIcon
                        />
                        <DatePicker
                            label={t('Third insurance start date')}
                            value={data.third?.insurance_start_date}
                            // disabled={data.third?.final_check}
                            onChange={date => changeData(date, 'insurance_start_date','third')}
                            required
                            isInsuranceDate
                        />
                        <DatePicker
                            label={t('Third insurance end date')}
                            value={data.third?.insurance_expire_date}
                            // disabled={data.third?.final_check}
                            onChange={date => changeData(date, 'insurance_expire_date','third')}
                            required
                            isInsuranceDate
                        />
                        </> 
                    }
                    {accidentInfo.insurance_type === 'body' &&
                    <>
                        {/* <div className='title mt20'><span className='line'/> <div className='body-title'>بیمه نامه بدنه مقصر</div> <span className='line'/></div>
                        <div className='row text-right' ref={form2}> */}
                            <Input
                                label='نام بیمه گزار بدنه'
                                value={data.body?.insurance_owner_name}
                                onChange={value => changeData(value, 'insurance_owner_name','body')}
                                name='fname'
                                required
                                // disabled={data.body?.final_check}
                            />
                            <Input
                                label='کد ملی بیمه گزار بدنه'
                                value={data.body?.insurance_owner_national_id}
                                maxLength={10}
                                mode='numeric'
                                name='nationalId'
                                onChange={value => changeData(value, 'insurance_owner_national_id','body')}
                                required
                                // disabled={data.body?.final_check}
                            />
                            <Input
                                label={t('Body insurance number')}
                                value={data.body?.insurance_number}
                                onChange={value => changeData(value, 'insurance_number','body')}
                                required
                                // disabled={data.body?.final_check}
                                minLength={4}
                            />
                            <SearchablePicker
                                label={t('Body insurance company')}
                                value={data.body?.insurance_company ||''}
                                data={includedInsurance}
                                rtl
                                placeholder='شرکت بیمه نامه بدنه'
                                titleKey='title'
                                valueKey='id'
                                required
                                // disabled={data.body?.final_check}
                                onSelect={val => changeData(val, 'insurance_company','body')}
                                hasIcon
                            />
                            <DatePicker
                                label={t('Body insurance start date')}
                                value={data.body?.insurance_start_date}
                                required
                                // disabled={data.body?.final_check}
                                onChange={date => changeData(date, 'insurance_start_date','body')}
                                isInsuranceDate
                            />
                            <DatePicker
                                label={t('Body insurance end date')}
                                value={data.body?.insurance_expire_date}
                                required
                                // disabled={data.body?.final_check}
                                onChange={date => changeData(date, 'insurance_expire_date','body')}
                                isInsuranceDate
                            />
                         {/* </div> */}
                    </>
                    }
                    </div>
                    {/* {   userType === 'culprit' &&
                         <div className='col-12 text-right'>
                            <label className='custom-checkbox mt20'>
                                <input type='checkbox' checked={hasBodyInsurance} 
                                onChange={(e) => {                                   
                                    if(!e.target.checked) {
                                        setAddBodyInsurance(false)
                                    }
                                    // setHasBodyInsurance(e.target.checked)
                                    changehasBodyInsurance(e.target.checked)
                                }} />
                                <span className='checkmark' />
                            </label>
                            <p className='use-body-text mr30'> قصد استفاده از بیمه بدنه را دارم </p>
                            {hasBodyInsurance && <div className='title mt20'><span className='line'/> <div className='body-title'>بیمه نامه بدنه مقصر</div> <span className='line'/></div>}
                        </div>
                    } */}
                    {/* {   hasBodyInsurance && data.body?.insurance_company &&
                            <>
                        <div className='d-flex car-info br5 p10 mt30'>                             
                        <div className='d-flex align-items-center mr10'>
                            {insuranceCompanies[data.body.insurance_company-1]?.title} - {data.body.insurance_number}
                            <img className='ml10' src={InsuranceInfoIcon}/>
                        </div>
                        </div> 
                        <div className='edit-text mt20'>
                            <p className='m5'> در صورت مغایرت اطلاعات ،با <span className='colorful-text' onClick={()=> setSupportCall(true)}>پشتیبانی</span> تماس حاصل نمایید.</p>
                        </div>                    
                         </>
                    } */}
                    <div className='group-btn mt20'>
                        <button 
                            className={`btn btn-circle btn-block btn-orange btn-bold`} 
                            onClick={changeStep}
                        >
                                مرحله قبل
                        </button>
                        <button 
                            className={`btn btn-circle btn-block btn-white-purple btn-bold`} 
                            onClick={()=>Submit('insurance')}
                            disabled={btnLoading}
                        >
                            {btnLoading ? <i className='fas fa-spinner fa-spin' />:' تایید و ادامه '}
                            {/* مرحله بعد */}
                    </button>
                    </div>
                    {/* {
                    !!((data.third?.insurance_company && data.third?.final_check)||(data.body?.insurance_company && data.body?.final_check)) &&
                        <button 
                            className={`btn btn-circle btn-block btn-yellow btn-bold mt10`} 
                            onClick={()=>setSupportCall(true)}
                            >عدم تایید و مغایرت</button>
                    } */}
                </>
  )
}
